import typeToReducer from 'type-to-reducer';
import merge from 'lodash/merge';

import * as types from './types';

const replaceState = (_state, { payload }) => payload;
const replacePayload = (state, { payload }) => ({ ...state, ...payload });
const deepMergePayload = (state, { payload }) => merge({}, state, payload);
const ignorePayload = state => ({ ...state });

export default typeToReducer({
  [types.CLASSES_GET]: {
    FULFILLED: replaceState,
  },
  [types.CLASSES_CREATE]: {
    FULFILLED: replacePayload,
  },
  [types.CLASSES_EDIT]: {
    FULFILLED: deepMergePayload,
  },
  [types.CLASSES_DELETE]: {
    FULFILLED: ignorePayload,
  },
}, null);
